import React from 'react';
import { Container, List, ListItem, Radio, FormErrorMessage } from '@groupelacentrale/contact-storybook';
import Aurore from 'assets/PaymentCard/aurore.png';
import CB from 'assets/PaymentCard/cb.png';
import EBleue from 'assets/PaymentCard/e-bleue.png';
import MasterCard from 'assets/PaymentCard/mastercard.png';
import Visa from 'assets/PaymentCard/visa.png';
import './PaymentCardSelect.scss';
import { PayboxTypeCarte } from 'types';

interface Props {
  name: string;
  value: PayboxTypeCarte;
  error?: string;
  onChange: (e: React.ChangeEvent) => void | undefined;
}

export const PaymentCardSelect: React.FC<Props> = ({ name, value, error, onChange }) => {
  return (
    <>
      <Container
        className="payment-card-select"
        shadowed
        backgroundColor="bgWhite"
        margins="mediumM"
        marginSides={['top']}
      >
        <List>
          <ListItem>
            <Radio
              name={name}
              theme="primary"
              value="CB"
              label={<img src={CB} alt="CB" />}
              onChange={onChange}
              checked={value === 'CB'}
            />
          </ListItem>
          <ListItem>
            <Radio
              name={name}
              theme="primary"
              value="VISA"
              label={<img src={Visa} alt="Visa" />}
              onChange={onChange}
              checked={value === 'VISA'}
            />
          </ListItem>
          <ListItem>
            <Radio
              name={name}
              theme="primary"
              value="EUROCARD_MASTERCARD"
              label={<img src={MasterCard} alt="MasterCard" />}
              onChange={onChange}
              checked={value === 'EUROCARD_MASTERCARD'}
            />
          </ListItem>
          <ListItem>
            <Radio
              name={name}
              theme="primary"
              value="AURORE"
              label={<img src={Aurore} alt="Aurore" />}
              onChange={onChange}
              checked={value === 'AURORE'}
            />
          </ListItem>
          <ListItem>
            <Radio
              name={name}
              theme="primary"
              value="E_CARD"
              label={<img src={EBleue} alt="E-Bleue" />}
              onChange={onChange}
              checked={value === 'E_CARD'}
            />
          </ListItem>
        </List>
      </Container>
      {error !== undefined && <FormErrorMessage name={name} message={error} />}
    </>
  );
};
